import React, { useState, useEffect } from "react";
import _ from "lodash";
import Socket from "socket";
import { motion } from "framer-motion/dist/framer-motion";

import {
  divVariants,
  logoExitVariants,
  logoEntryVariants,
  slide_bounce_variants,
  bounce_right_to_left_variants
} from "shared/components/animations";
import promptIcon from "assets/images/gah/prompt.png";
import rectBig from "assets/images/gah/rectangle-big.png";
import bannerLogo from "assets/images/gah/others-banner.png";

const ReadingActive = ({
  roomId,
  prompt,
  status,
  played_cards,
  onEvaluateCard,
  isReading = false,
  isEvaluating = false
}) => {
  const [flippedArray, setFlippedArray] = useState([]);
  const allCardsFlipped = played_cards.every((item) => item.flipped);

  useEffect(() => {
    const array = played_cards.map((item) => ({
      cardId: item.card.id,
      flipped: false,
      opacityValue: 1
    }));
    setFlippedArray([...array]);
  }, []);

  const calculateOpacity = (id) => {
    setTimeout(() => {
      const array = flippedArray.map((item) =>
        item.cardId === id ? { ...item, opacityValue: 0 } : item
      );
      setFlippedArray([...array]);
    }, 800);
  };

  const handleFlipCard = (id) => {
    const array = flippedArray.map((item) =>
      item.cardId === id
        ? { ...item, flipped: true, opacityValue: calculateOpacity(id) }
        : item
    );
    setFlippedArray([...array]);
    const data = {
      action: "flip-card",
      roomId: roomId,
      cardId: id
    };
    Socket.sendMessage(data);
  };

  useEffect(() => {
    if (isReading && allCardsFlipped) {
      updateRoomForEvaluation();
    }
  }, [isReading, allCardsFlipped]);

  const updateRoomForEvaluation = () => {
    const data = {
      action: "update-status",
      roomId: roomId
    };
    setTimeout(() => {
      Socket.sendMessage(data);
    }, 4000);
  };

  const isFlipped = (id) => {
    if (!_.isEmpty(flippedArray))
      return flippedArray.find((item) => item.cardId === id).flipped;
  };

  const opacityClass = (id) => {
    if (!_.isEmpty(flippedArray))
      return flippedArray.find((item) => item.cardId === id).opacityValue;
    else return 1;
  };

  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="reading-active"
    >
      <motion.div
        variants={
          status === "Reading"
            ? logoEntryVariants
            : status === "Result"
            ? logoExitVariants
            : {}
        }
        className="big-top-banner"
      >
        <img alt="" src={rectBig} className="rect-big" />
        <div className="prompt-div">
          <h2>{prompt}</h2>
        </div>
        <img alt="" src={promptIcon} className="prompt" />
      </motion.div>

      <motion.div
        variants={slide_bounce_variants}
        className={`gifs-container reading ${isEvaluating ? "evaluating" : ""}`}
      >
        {played_cards.map((item, index) =>
          item.flipped ? (
            <div
              key={index}
              className={`common-card-wrapper flip ${
                status === "Reading" ? "flipInYReading" : ""
              }`}
            >
              <div className={`title-div ${isEvaluating ? "evaluating" : ""}`}>
                <h2>{item.card.text}</h2>
              </div>

              <div className="gif-div">
                <img alt="" src={item.card.gif_url} />
              </div>

              {isEvaluating && (
                <div
                  className={`flip-div ${isEvaluating ? "evaluating" : ""}`}
                  onClick={() => onEvaluateCard(item.card)}
                >
                  <div
                    className={`button-border-div ${
                      isEvaluating ? "evaluating" : ""
                    }`}
                  />
                  <h2>SELECT</h2>
                </div>
              )}
            </div>
          ) : (
            <div
              key={index}
              className={`pre-reading-div ${
                isFlipped(item.card.id) ? "flipOutYReading" : ""
              } ${opacityClass(item.card.id) === 0 ? "opacityZero" : ""}`}
            >
              <div className="border-div" />
              <h2 className="primary-text">GIFs Against Society</h2>
              <div
                className="flip-div"
                onClick={() => handleFlipCard(item.card.id)}
              >
                <div className="button-border-div" />
                <h2>FLIP</h2>
              </div>
            </div>
          )
        )}
      </motion.div>

      {isEvaluating && (
        <motion.div
          variants={bounce_right_to_left_variants}
          className={`top-others-banner ${isEvaluating ? "evaluating" : ""}`}
        >
          <img alt="" src={bannerLogo} />
          <h2 className="banner-text">SELECT WINNER</h2>
        </motion.div>
      )}
    </motion.div>
  );
};

export default ReadingActive;
